import React from 'react';
import { Pagination } from 'react-bootstrap';
import { FaAngleDoubleLeft, FaAngleLeft, FaAngleDoubleRight, FaAngleRight } from 'react-icons/fa';

const Paginacao = ({ currentPage, totalPages, onPageChange }) => {
  const renderPaginationItems = () => {
    const pageNumbers = [];
    const maxPagesToShow = 5;

    let startPage = Math.max(currentPage - Math.floor(maxPagesToShow / 2), 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    if (startPage > 1) {
      pageNumbers.push(
        <Pagination.Item key={1} active={currentPage === 1} onClick={() => onPageChange(1)}>
          1
        </Pagination.Item>
      );
      if (startPage > 2) {
        pageNumbers.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={currentPage === i} onClick={() => onPageChange(i)}>
          {i}
        </Pagination.Item>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      pageNumbers.push(
        <Pagination.Item key={totalPages} active={currentPage === totalPages} onClick={() => onPageChange(totalPages)}>
          {totalPages}
        </Pagination.Item>
      );
    }

    return pageNumbers;
  };

  return (
    <Pagination>
      <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        <FaAngleDoubleLeft />
      </Pagination.First>
      <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
        <FaAngleLeft />
      </Pagination.Prev>
      {renderPaginationItems()}
      <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
        <FaAngleRight />
      </Pagination.Next>
      <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages}>
        <FaAngleDoubleRight />
      </Pagination.Last>
    </Pagination>
  );
};

export default Paginacao;
